import DynamicFormFieldDefinitionResourceListResultModel from '../../generated/types/model/resource/DynamicFormFieldDefinitionResourceListResultModel';

export default class DynamicFormFieldDefinitionResourceListResultViewModel extends DynamicFormFieldDefinitionResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
